<span class="countdown-label" [ngClass]="{'char-limit-reached': inputCharLimit <= 0}">{{inputCharLimit}} / {{maxlength}}</span>
